module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Visitor",
      "visible": _vm.addDisplayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.addDisplayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addTicketDetails.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-primary",
          attrs: {
            "label": "Add & New"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addAndNewTicketDetails.apply(null, arguments)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "address"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "contactnumber"
    }
  }, [_vm._v("Contact Number"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactnumber"
    },
    model: {
      value: (_vm.contactnumber),
      callback: function($$v) {
        _vm.contactnumber = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "contactnumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "purpose"
    }
  }, [_vm._v("Purpose")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "purpose"
    },
    model: {
      value: (_vm.purpose),
      callback: function($$v) {
        _vm.purpose = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "purpose"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "visittoid"
    }
  }, [_vm._v("Visit To")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "visittoid"
    },
    model: {
      value: (_vm.visitTo),
      callback: function($$v) {
        _vm.visitTo = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "visitTo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "inTime"
    }
  }, [_vm._v("In Time")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "type": "time",
      "id": "inTime",
      "placeholder": "Select time (HH:mm)",
      "time-picker-options": {
        start: '08:00',
        step: '00:30',
        end: '20:00'
      },
      "format": "HH:mm",
      "value-type": "format"
    },
    model: {
      value: (_vm.inTime),
      callback: function($$v) {
        _vm.inTime = $$v
      },
      expression: "inTime"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "p-d-block p-mt-1 p-text-secondary"
  }, [_vm._v("\n                Enter time in 24-hour format (e.g., 14:30)\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "outTime"
    }
  }, [_vm._v("Out Time")]), _vm._v(" "), _c('DatePicker', {
    attrs: {
      "type": "time",
      "id": "outTime",
      "placeholder": "Select time (HH:mm)",
      "time-picker-options": {
        start: '08:00',
        step: '00:30',
        end: '20:00'
      },
      "format": "HH:mm",
      "value-type": "format"
    },
    model: {
      value: (_vm.outTime),
      callback: function($$v) {
        _vm.outTime = $$v
      },
      expression: "outTime"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "p-d-block p-mt-1 p-text-secondary"
  }, [_vm._v("\n                Enter time in 24-hour format (e.g., 14:30)\n              ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('Textarea', {
    staticClass: "form-control",
    attrs: {
      "id": "description",
      "rows": "3"
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1)])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f67ce25e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crmDialog/crmVisitorDetailsDialog.vue
// module id = 2440
// module chunks = 0